module.exports = __webpack_public_path__ + "img/tweet-icon-white.0e7e0d9.svg";